import { RouteGeometry, VoyageRouteLineFeature } from "../models/voyage-routing-model";

export const legForEndPoint = (legs: VoyageRouteLineFeature[], coord: [number, number], idx: number): VoyageRouteLineFeature|undefined => {
    const res = legs.filter(leg => {
        const coords = leg.geometry.coordinates;
        return coords && coords.length === 2 &&
            coords[idx].length === 2 &&
            coords[idx][0] === coord[0] &&
            coords[idx][1] === coord[1];
    })

    if (res.length === 1) return res[0];
}

export const toDegrees = (rad: number): number => rad * 180 / Math.PI;
export const toRadians = (deg: number): number => Math.PI * deg / 180;

// Remove past points/legs and informational points
export function pruneRouteGeometry(geometry: RouteGeometry): RouteGeometry
{
    const result: RouteGeometry = [];

    let lastPointNotPassed = false;
    for (const feature of geometry)
    {
        if (feature.geometry.type === "LineString" && lastPointNotPassed)
        {
            result.push(feature);
        }
        else if (feature.geometry.type === "Point" && !feature.properties.isPassed &&
                 (feature.properties.type === "Hard" || feature.properties.type === "Navigational"))
        {
            lastPointNotPassed = true;
            result.push(feature);
        }
    }

    return result;
}
